<style scoped>
.compare-table {
  width: 100%;
  padding: 0 0 10px 0;
}
.compare-table td {
  padding: 10px 10px;
}
.compare-table td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.149) !important;
}
.compare-table-paramenter {
  width: 150px !important;
}
</style>
<template>
  <div>
    <v-dialog v-model="dialog.flag" width="900">
      <v-card class="pb-0">
        <v-card-title class="text-h6 primary_2 white--text" primary-title>
          <p>Compare PAN Details</p>
          <v-spacer></v-spacer>
          <v-icon large v-if="is_pan_pdf" color="white"
            >mdi-file-pdf-box</v-icon
          >
          <v-icon large v-else color="white">mdi-file-jpg-box</v-icon>
          <v-btn
            small
            text
            color=""
            class="white py-4 mx-3"
            @click="
              isImageDocument(dialog.pan_url)
                ? previewImage(dialog.pan_url, 'PAN Card')
                : viewDocument(dialog.pan_url)
            "
          >
            <v-icon color="deep-purple darken-4">mdi-eye-outline</v-icon>
          </v-btn>
          <v-btn fab text small>
            <v-icon large color="white" @click="dialog.flag = false">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <table class="font-weight-bold compare-table">
            <tr class="font-weight-bold black--text">
              <td class="compare-table-paramenter">Paramenters</td>
              <td>Customer filled data</td>
              <td v-if="dialog.pan_fetch_response.name">
                PAN Fetch Data from Signzy
              </td>
              <td v-if="dialog.pan_ocr_response.number">
                PAN OCR Data from Signzy
              </td>
              <td>Aadhaar Data from Signzy</td>
            </tr>
            <tr>
              <td class="black--text">Full Name</td>
              <td>{{ dialog.user_fiiled_data.name }}</td>
              <td v-if="dialog.pan_fetch_response">
                  {{ dialog.pan_fetch_response.name }}
              </td>
              <td v-if="dialog.pan_ocr_response.name">
                  {{ dialog.pan_ocr_response.name }}
              </td>
              <td>
                {{ dialog.aadhaar_details.name }}
              </td>
            </tr>
            <tr>
              <td class="black--text">Date of Birth</td>
              <td>{{ dialog.user_fiiled_data.dob }}</td>
              <td v-if="dialog.pan_fetch_response">
                  {{ dialog.pan_fetch_response.dob }}
              </td>
              <td v-if="dialog.pan_ocr_response.dob">
                  {{ ocdDob }}
              </td>
              <td>{{ dialog.aadhaar_details.date_of_birth }}</td>
            </tr>
            <tr>
              <td class="black--text">Father's Name</td>
              <td>{{ dialog.user_fiiled_data.father_name }}</td>
              <td v-if="dialog.pan_fetch_response">
                  {{ dialog.pan_fetch_response.fatherName }}
              </td>
              <td v-if="dialog.pan_ocr_response.fatherName">
                <p>
                  {{ dialog.pan_ocr_response.fatherName }}
                </p>
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="black--text">PAN number</td>
              <td>{{ dialog.user_fiiled_data.pan_number }}</td>
              <td v-if="dialog.pan_fetch_response">
                  {{ dialog.pan_fetch_response.number }}
              </td>
              <td v-if="dialog.pan_ocr_response.number">
                <p>
                  {{ dialog.pan_ocr_response.number }}
                </p>
              </td>
              <td></td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions
          v-if="dialog.aadhaar_status == 'Under Review'"
          class="d-flex justify-end pb-6 pr-6"
        >
          <v-btn
            outlined
            small
            color="success"
            :disabled="btn_loader"
            :loading="btn_loader"
            class="font-weight-bold ml-2"
            @click="updateKycStatus('pan_status', 'Success')"
          >
            Apporve
          </v-btn>
          <v-btn
            small
            outlined
            color="error"
            class="font-weight-bold ml-2"
            @click="updateKycStatus('pan_status', 'Failed')"
          >
            Reject
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["dialog"],
  data() {
    return {
      is_pan_pdf: false,
      btn_loader: false,
    };
  },
  mounted() {
    this.isImageDocument(this.dialog.pan_url)
      ? (this.is_pan_pdf = false)
      : (this.is_pan_pdf = true);
  },
  computed: {
    ocdDob() {
      let date = this.dialog.pan_ocr_response.dob;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    // view document
    viewDocument(url) {
      window.open(url, "_blank");
    },

    // returning true if image extension is png, jpg or, jpeg
    isImageDocument(url) {
      let ext = url.split(".");
      ext = ext[ext.length - 1];
      return ext == "png" || ext == "jpg" || ext == "jpeg" || ext == "webp";
    },
    // if isImageDocument returns true then opens image in new tab
    previewImage(url, document_name) {
      console.log("image preview", url);
      let image_url = url;

      let route = this.$router.resolve({
        name: "view-image",
        params: {
          image: this.encript(image_url),
          document: this.encript(document_name),
        },
      });
      window.open(route.href, "_blank");
    },
    // post updated aadhaar status
    updateKycStatus(document_type, action) {
      const self = this;

      self.btn_loader = true
      // console.log("type", document_type, "action", action);
      let form = new FormData();
      form.append("customer_id", self.decrypt(self.$route.params.id));
      form.append("kyc_field", document_type);
      form.append("kyc_status", action);
      const successHandler = (response) => {
        if (response.data.success) {
          // console.log("kyc update res",response);
          self.$emit("success");
          this.dialog.flag = false;
        }
      };
      const finallyHandler = () => {
        self.btn_loader = false
      };
      self.request_POST(
        self,
        self.$urls.NEW_CUSTOMER_UPDATE_KYC_STATUS,
        form,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },
  },
};
</script>
